import { inject } from "inversify";
import {
  ShowErrorModal,
  PROVIDE_KEY_SHOW_ERROR_MODAL,
} from "./../../types/index";
import { Ref, ref } from "vue";
import { useUserStore } from "@/stores/userStore";
import useFormattingPhoneNumber from "@/use/useFormattingPhoneNumber";
import useUnformattingPhoneNumber from "@/use/useUnformattingPhoneNumber";

export default function validatePhoneNum(): {
  phoneNumber: Ref<string>;
  verificationTitle: Ref<string>;
  didSendVerificationCode: Ref<boolean>;
  phoneNumberErrorMessage: Ref<string>;
  onChangePhoneNumber: () => void;
  sendPhoneVerificationCode: () => void;
} {
  const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

  const userStore = useUserStore();

  const phoneNumber = ref("");
  const verificationTitle = ref("인증요청");
  const didSendVerificationCode = ref(false);
  const phoneNumberErrorMessage = ref("");

  const onChangePhoneNumber = () => {
    phoneNumber.value = useFormattingPhoneNumber(phoneNumber.value);
    phoneNumberErrorMessage.value = "";
  };

  const sendPhoneVerificationCode = async () => {
    verificationTitle.value = "재요청";
    const verificationCodeResult = await userStore.sendPhoneVerificationCode(
      useUnformattingPhoneNumber(phoneNumber.value)
    );
    if (verificationCodeResult.isSuccess) {
      didSendVerificationCode.value = true;
      return;
    }
    didSendVerificationCode.value = false;
    if (
      verificationCodeResult.resultCode === 409000005 ||
      verificationCodeResult.resultCode === 409000006
    ) {
      phoneNumberErrorMessage.value =
        "이미 등록되거나 탈퇴한지 1주일이 되지 않은 휴대폰 번호입니다.";
      return;
    }
    showErrorModal(
      "인증번호 요청 오류",
      verificationCodeResult.errorMessage,
      verificationCodeResult.resultCode,
      verificationCodeResult.errorTime
    );
  };

  return {
    phoneNumber,
    verificationTitle,
    didSendVerificationCode,
    phoneNumberErrorMessage,
    onChangePhoneNumber,
    sendPhoneVerificationCode,
  };
}
